export enum AzureAdRoles {
    AzureActiveDirectoryAdminRole = "VideoPortalAdmin",
    AzureActiveDirectoryViewDomesticRole = "ViewDomestic",
    AzureActiveDirectoryViewCommercialRole = "ViewCommercial",
    AzureActiveDirectoryUserRole = "VideoPortalUser",
}
